const liff = window.liff;

export const getProfile = async () => {
  const profile = await liff.getProfile();
  const email = await liff.getDecodedIDToken().email;

  return { profile: profile, email: email };
};
